import edgeSVG from '@/assets/edge.svg'
import type { FC } from 'react'

type EdgeSubstructProps = {
	className?: string
}

export const EdgeSubstruct: FC<EdgeSubstructProps> = ({ className }) => {
	return (
		<svg
			viewBox="0 0 100 64"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			aria-hidden="true"
		>
			<title>Edge</title>
			<use href={`${edgeSVG.src}#asset-edge-subtract`} />
		</svg>
	)
}

export default EdgeSubstruct
